import { useContext } from 'react'
import { useLocation } from 'react-router-dom'
import Tooltip from '@mui/material/Tooltip'
import { SidebarContext } from '../../../../shared/contexts/SidebarContext'
import {
  subscribersPath,
  subscriptionPath,
  subscriptionMetricsPath,
  aiSpendPath,
  assistantConfigPath,
  adminPath,
  supportPath,
  impersonationAuditPath,
  settingsPath,
  settingsSessionsPath,
} from '../../../../logic/paths'
import { NavGroup, NavItemLink, NavItemIcon, NavItemText } from '../Sidebar.styled'

const SubscribersIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor">
    <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z" />
  </svg>
)

const SubscriptionIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor">
    <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V8l8 5 8-5v10zm-8-7L4 6h16l-8 5z" />
  </svg>
)

const AdminIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
  </svg>
)

const SupportIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor">
    <path d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 9h12v2H6V9zm8 5H6v-2h8v2zm4-6H6V6h12v2z" />
  </svg>
)

const ImpersonationAuditIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor">
    <path d="M13 3a9 9 0 0 0-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42A8.954 8.954 0 0 0 13 21a9 9 0 0 0 0-18zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z" />
  </svg>
)

const SettingsIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor">
    <path d="M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58c.18-.14.23-.41.12-.61l-1.92-3.32c-.12-.22-.37-.29-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54c-.04-.24-.24-.41-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.07.62-.07.94s.02.64.07.94l-2.03 1.58c-.18.14-.23.41-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61l-2.01-1.58zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6z" />
  </svg>
)

const MetricsIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor">
    <path d="M3.5 18.49l6-6.01 4 4L22 6.92l-1.41-1.41-7.09 7.97-4-4L2 16.99z" />
  </svg>
)

const AiSpendIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor">
    <path d="M19 9l1.25-2.75L23 5l-2.75-1.25L19 1l-1.25 2.75L15 5l2.75 1.25L19 9zm-7.5.5L9 4 6.5 9.5 1 12l5.5 2.5L9 20l2.5-5.5L17 12l-5.5-2.5zM19 15l-1.25 2.75L15 19l2.75 1.25L19 23l1.25-2.75L23 19l-2.75-1.25L19 15z" />
  </svg>
)

const AssistantIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor">
    <path d="M21 6h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1zm-4 6V3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1z" />
  </svg>
)

const SessionsIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor">
    <path d="M4 6h18V4H4c-1.1 0-2 .9-2 2v11H0v3h14v-3H4V6zm19 2h-6c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zm-1 9h-4v-7h4v7z" />
  </svg>
)

interface MenuItem {
  path: string
  label: string
  icon: React.ReactNode
  matchPaths?: string[]
  requireRole?: string
}

const menuItems: MenuItem[] = [
  {
    path: subscribersPath,
    label: 'Subscribers',
    icon: <SubscribersIcon />,
    matchPaths: ['subscribers', 'subscriber-details'],
  },
  {
    path: subscriptionPath,
    label: 'Subscription Plans',
    icon: <SubscriptionIcon />,
  },
  {
    path: subscriptionMetricsPath,
    label: 'Metrics',
    icon: <MetricsIcon />,
    matchPaths: ['subscription-metrics'],
  },
  {
    path: aiSpendPath,
    label: 'AI Spend',
    icon: <AiSpendIcon />,
    matchPaths: ['ai-spend'],
  },
  {
    path: assistantConfigPath,
    label: 'PWP Assistant',
    icon: <AssistantIcon />,
    matchPaths: ['assistant-config'],
    requireRole: 'superadmin',
  },
  {
    path: adminPath,
    label: 'Admin',
    icon: <AdminIcon />,
    requireRole: 'superadmin',
  },
  { path: supportPath, label: 'Support', icon: <SupportIcon /> },
  {
    path: impersonationAuditPath,
    label: 'Impersonation audit',
    icon: <ImpersonationAuditIcon />,
    matchPaths: ['impersonation-audit'],
  },
  { path: settingsPath, label: 'Settings', icon: <SettingsIcon /> },
  {
    path: settingsSessionsPath,
    label: 'Active Sessions',
    icon: <SessionsIcon />,
    matchPaths: ['sessions'],
  },
]

function SidebarMenu({ isCollapsed = false }: { isCollapsed?: boolean }) {
  const { closeSidebar } = useContext(SidebarContext)
  const location = useLocation()
  const role = JSON.parse(localStorage.getItem('role') || 'null')

  return (
    <NavGroup>
      {menuItems.map((item) => {
        if (item.requireRole && role !== item.requireRole) return null
        const isActive = item.matchPaths?.some((p) => location.pathname.includes(p)) || false

        const link = (
          <NavItemLink
            key={item.path}
            to={item.path}
            onClick={closeSidebar}
            $isCollapsed={isCollapsed}
            className={isActive ? 'active' : undefined}
          >
            <NavItemIcon>{item.icon}</NavItemIcon>
            <NavItemText $isCollapsed={isCollapsed}>{item.label}</NavItemText>
          </NavItemLink>
        )

        return isCollapsed ? (
          <Tooltip key={item.path} title={item.label} placement="right">
            {link}
          </Tooltip>
        ) : (
          link
        )
      })}
    </NavGroup>
  )
}

export default SidebarMenu
